import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { useAuth } from '@hooks/useAuth';
import { LockIcon, LogoIcon } from '@icons';
import '@components/ExpiredLink/ExpiredLink.less';

type InvitationEmailMismatchProps = {
  invitationEmail: string;
  actualEmail: string;
};

export default function InvitationEmailMismatch(
  props: InvitationEmailMismatchProps
) {
  const navigate = useNavigate();
  const { login } = useAuth();
  return (
    <div className="expired_link_container">
      <a
        className="expired_link_container__logotype"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate('/');
        }}
      >
        <LogoIcon className="logo" />
      </a>
      <div className="expired_link_container__body">
        <LockIcon />
        <div className="title">Your email does not match the invite email</div>
        <div className="description">
          The invite was sent to {props.invitationEmail} but you are currently
          logged in as {props.actualEmail}. Please log in with the correct email
          to accept the invitation.
        </div>
        <Button
          type="primary"
          onClick={() =>
            login({
              authorizationParams: { prompt: 'login' },
              appState: {
                returnTo: window.location.pathname + window.location.search
              }
            })
          }
        >
          Sign in
        </Button>
      </div>
      <div className="expired_link_container__footer" style={{ height: 36 }} />
    </div>
  );
}
